<template>
    <div class="city-table"
         v-bind:class="{ show : animateStart}"
    >
        <div class="row">
            <div class="col l7ths s12 paddingfix"
                 v-for="(env, key) in envList"
                 :key="key"
            >
                <div class="table-item"
                     @mouseover="activateOficeMenu(env.slug, true)"
                     @mouseleave="activateOficeMenu(env.slug,false)"
                >
                    <div class="img-wrap unselectable"
                    >
                        <div class="env-img"
                             v-if="env.icon"
                        >

                            <img class="img"
                                 :src="env.icon"
                            />
                        </div>
                        <div class="sub-menu"
                             v-bind:class="{active : activeOficeMenu}"
                            v-if="env.slug == 'groupoffice'"
                        >
                            <ul>
                                <li
                                    v-for="(item, key) in env.subenv"
                                    v-on:click="selectEnvironment(item.id)"
                                >
                                    {{item.title}}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="envbutton"
                         v-on:click="selectEnvironment(env.id)"
                    >
                        {{env.title}}

                    </div>
                    <div class="text-wrap"
                    >
                        <div class="description"
                        >
                            {{env.description}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CityTable",
        props: ['tablePlace'],
        data() {
            return {

                minImageHeight1: 100,
                minImageHeight2: 100,
                minTextHeight1: 100,
                minTextHeight2: 100,
                animateStart: false,
                activeOficeMenu: false
            }
        },
        watch: {
            'tablePlace'() {
                // setTimeout(this.setMinHeight(),100);
            }
        },
        computed: {
            envList: function () {
                let navList = [];
                this.globalData.environments.forEach((item, i) => {
                    let item_element = {
                        id: item.id,
                        icon: item.icon,
                        slug: item.slug,
                        title: item.title,
                        description: item.description,
                    }
                    if (item.grouptype) {
                        item_element.subenv = this.globalData.environments.filter((el) => {
                            return el.parent == item.id;
                        });
                        navList.push(item_element)
                    } else if (!item.parent) {
                        navList.push(item_element)
                    }
                });
                return navList;
            }
        },
        mounted() {
            window.addEventListener('load', () => {
                this.setMinHeight();
            });
            setTimeout(() => {
                this.setMinHeight()
            }, 100);
        },
        methods: {
            activateOficeMenu(slug,statsus){
                    if (slug == 'groupoffice'){
                        this.activeOficeMenu = statsus;
                    }
            },
            selectEnvironment(id) {
                this.$emit('setActiveEnv', id);
            },
            setMinHeight() {
                this.animateStart = true;
                let iHs=[];
                let items = document.getElementsByClassName("table-item");
                items.forEach((item, i) => {
                    let id = item.offsetTop
                        if (!iHs.hasOwnProperty(id)){
                            iHs[id]={
                                imgH:0,
                                imgT:0,
                            };
                        }
                    if (iHs[id].imgH < item.querySelector('.env-img').offsetHeight) {
                        iHs[id].imgH = item.querySelector('.env-img').offsetHeight
                    }
                    if (iHs[id].imgT < item.querySelector('.description').offsetHeight) {
                        iHs[id].imgT = item.querySelector('.description').offsetHeight
                    }
                });
                items.forEach((item, i) => {
                    let id = item.offsetTop
                    if (iHs.hasOwnProperty(id)){
                        item.querySelector('.img-wrap').style.minHeight = iHs[id].imgH+'px';
                        item.querySelector('.text-wrap').style.minHeight = iHs[id].imgT+'px';
                    }
                });
            }
        },
        updated() {
            // setTimeout(() => {
            //     this.setMinHeight()
            // }, 100);
        },
        created() {
            window.addEventListener("resize", this.setMinHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.setMinHeight);
        },
    }
</script>

<style lang="scss" scoped>

</style>